
function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

const routes_base = [
  {path: 'pickup/product/create', component: loadPage('PickupProductCreate', 'pickup/product')},
  {path: 'pickup/product', component: loadPage('PickupProductList', 'pickup/product')},
  {path: 'pickup/order/detail', component: loadPage('OrderDetail', 'pickup/order')},
  {path: 'pickup/order_list_order', component: loadPage('OrderListOrder', 'pickup/order')},
  {path: 'pickup/order_list_pay_new', component: loadPage('OrderListPayNew', 'pickup/order')},
  {path: 'pickup/order_list_pay_all', component: loadPage('OrderListPayAll', 'pickup/order')},
  {path: 'pickup/order_create', component: loadPage('OrderCreate', 'pickup/order')},
  {path: 'pickup/order_list_goods_new', component: loadPage('OrderListGoodsNew', 'pickup/goods')},
  {path: 'pickup/order_list_goods_all', component: loadPage('OrderListGoodsAll', 'pickup/goods')},
  {path: 'pickup/order_list_pickup_new', component: loadPage('OrderListPickupNew', 'pickup/pickup')},
  {path: 'pickup/order_list_pickuping', component: loadPage('OrderListPickuping', 'pickup/pickup')},
  {path: 'pickup/order_list_pickup_all', component: loadPage('OrderListPickupAll', 'pickup/pickup')},
  {path: 'pickup/order_list_pickup_success', component: loadPage('OrderListPickupSuccess', 'pickup/pickup')},
  {path: 'pickup/order_list_settle', component: loadPage('OrderListSettle', 'pickup/pickup')},
  {path: 'pickup/order_list_cancel_new', component: loadPage('OrderListCancelNew', 'pickup/cancel')},
  {path: 'pickup/order_list_cancel_all', component: loadPage('OrderListCancelAll', 'pickup/cancel')},
  {path: 'pickup/order_list_back_new', component: loadPage('OrderListReturnNew', 'pickup/return')},
  {path: 'pickup/order_list_back_all', component: loadPage('OrderListReturnAll', 'pickup/return')},
  {path: 'pickup/order_list_backing', component: loadPage('OrderListReturning', 'pickup/return')},
  {path: 'pickup/order_list_refund_new', component: loadPage('OrderListRefundNew', 'pickup/refund')},
  {path: 'pickup/order_list_refund_all', component: loadPage('OrderListRefundAll', 'pickup/refund')},
  {path: 'pickup/order_list_exchange_new', component: loadPage('OrderListExchangeNew', 'pickup/exchange')},
  {path: 'pickup/order_list_exchange_all', component: loadPage('OrderListExchangeAll', 'pickup/exchange')},
  {path: 'pickup/order_list_exchanging', component: loadPage('OrderListExchanging', 'pickup/exchange')},
  {path: 'pickup/order_list_exchange_success', component: loadPage('OrderListExchangeSuccess', 'pickup/exchange')},
  {path: 'pickup/order_list_exchange_goods', component: loadPage('OrderListExchangeGoods', 'pickup/exchange')},
  {path: 'pickup/order_list_exchange_pickup_new', component: loadPage('OrderListExchangePickupNew', 'pickup/exchange')},
  {path: 'pickup/order_list_exchange_pickup_all', component: loadPage('OrderListExchangePickupAll', 'pickup/exchange')},
  {path: 'pickup/order_list_exchange_pickup_settle', component: loadPage('OrderListExchangeSettle', 'pickup/exchange')},
  {path: 'pickup/order_setting', component: loadPage('OrderSetting', 'pickup/order') },
  // 정산
  { path: 'pickup/account/new', component: loadPage('AccountNew', 'pickup/account') },
  { path: 'pickup/account/all', component: loadPage('AccountAll', 'pickup/account') },
  { path: 'pickup/account/setting', component: loadPage('AccountSetting', 'pickup/account') },

  // 포인트
  { path: 'pickup/point/setting', component: loadPage('PointSetting', 'point') },

];


const routes_admin = [

];


const routes = {
  'base': routes_base,
  'admin': routes_admin.concat(routes_base)
};

export default routes;

